import { isRejected } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { toastResponse } from "../../Components/Common/Toast/Toast";
import { globalError } from "../../utils/global-error-handler";
import { setUnauthorizedForceLogout } from "./stripe/stripeSlice";
import { setLoaderFalse } from "../../Redux/loaderSlice";

export const rtkQueryErrorLogger = (api) => (next) => (action) => {
  // isRejectedWithValue Or isRejected
  if (isRejected(action)) {
    if (
      Number.isInteger(action.payload?.status) &&
      action.payload?.status !== 200
    ) {
      if (action.payload?.status === 401) {
        api.dispatch(setUnauthorizedForceLogout(true));
        api.dispatch(setLoaderFalse());
      } else if (action.payload?.status !== 404) {
        if (action.payload?.data?.error !== "EWI_NOT_FOUND")
          toast.error(
            toastResponse(
              "error",
              globalError({
                data: {
                  data: "",
                  error: action?.payload?.data?.error,
                  message: action?.payload?.data?.message,
                  status: "ERROR",
                },
              }).message,
            ),
          );
      }
    }
  }

  return next(action);
};
